<template>
  <div class="layout">
    <attendee-header-mobile/>

    <div class="layout__container"
         v-touch:swipe.left="goNext"
         v-touch:swipe.right="goPrev"
    >
      <div class="layout__sidebar">
        <attendee-sidebar/>
      </div>
      <div class="layout__right">
        <div class="layout__header">
          <attendee-header/>
        </div>
        <main class="layout__content"
              v-if="isMobile"
        >
          <transition :name="transitionName" mode="out-in">
            <router-view class="page" :key="$route.fullPath" />
          </transition>
        </main>

        <main class="layout__content" v-else>
          <router-view></router-view>
        </main>
      </div>
    </div>


    <div class="layout__mobile-menu">
      <ul>
        <li
          v-for="(item, index) in navigation"
          :class="{
            active: $route.path.includes('agenda') && agendaRoute === item.path || $route.path.includes('ce-info') && ceRoute === item.path
          }"
          :key="index"
        >
          <router-link :to="item.path">
            <i :class="`fa-regular ${item.icon}`"></i> {{ item.name }}
          </router-link>
        </li>
      </ul>
    </div>

    <beacon v-show="!isMobile"/>
  </div>
</template>


<script>
import {mapGetters} from "vuex";
import {ROUTES} from "../router";
import AttendeeHeader from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import CommonMenu from "../components/layout/CommonMenu";
import AttendeeSidebar from "../components/layout/attendeeSidebar";
import Notify from "../components/ui/Notify/index";
import Container from "../components/ui/Container/index";
import Beacon from "../components/ui/Beacon";
import DropDownMenu from "../components/layout/DropDownMenu";
import AttendeeHeaderMobile from "../components/layout/AttendeeHeaderMobile";

export default {
  components: {
    Container,
    AttendeeHeader,
    Footer,
    CommonMenu,
    AttendeeSidebar,
    Notify,
    Beacon,
    DropDownMenu,
    AttendeeHeaderMobile,
  },
  computed: {
    ...mapGetters('attendeeStore', [
      'attendee',
      'notification',
      'isSingleSession',
      'sidebarMenu',
      'hideCeInformation'
    ]),

    isMobile() {
      return this.windowWidth < 900;
    }
  },
  data() {
    return {
      transitionName: '',   // за замовчуванням немає анімації
      // isMobile: false,


      module: '',
      attendeeId: this.$route.params.attendeeId,
      agendaRoute: ROUTES.AGENDA_EVENT.replace(':attendeeId', this.$route.params.attendeeId),
      ceRoute: ROUTES.CE_INFO.replace(':attendeeId', this.$route.params.attendeeId),
      navigation: [],
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 1200
    }
  },
  mounted() {
    this.fetchAttendee();

    // keep isMobile in sync with viewport changes
    this.onResize();
    window.addEventListener('resize', this.onResize, {passive: true});
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {

    goNext() {
      if(this.isMobile) {
        this.transitionName = 'slide-left'
        this.$router.go(1)

        setTimeout(() => {
          this.transitionName = ''
        }, 200)
      }


    },
    goPrev() {
      if(this.isMobile) {
        this.transitionName = 'slide-right'
        this.$router.go(-1)

        setTimeout(() => {
          this.transitionName = ''
        }, 200)
      }
    },

    onResize() {
      this.windowWidth = window.innerWidth;
    },

    fetchAttendee() {
      this.navigation.push({
        name: 'Home',
        path: ROUTES.AGENDA_HOME.replace(':attendeeId', this.attendeeId),
        icon: 'fa-house',
      });

      this.$store.dispatch("attendeeStore/fetchAttendee", {id: this.attendeeId})
        .then(() => {
          if (this.isSingleSession) {
            this.navigation.push({
              name: 'Event',
              icon: 'fa-calendar-check',
              path: ROUTES.SINGLE_EVENT.replace(':attendeeId', this.attendeeId),
            });
          } else {
            this.navigation.push({
              name: 'Schedule',
              icon: 'fa-calendar-check',
              path: ROUTES.AGENDA_EVENT.replace(':attendeeId', this.attendeeId),
            });
          }

          // scan in/out
          if (this.sidebarMenu.scan_in_out) {
            this.navigation.push({
              name: 'Scan in/out',
              path: ROUTES.SCAN_IN_OUT.replace(':attendeeId', this.attendeeId),
              icon: 'fa-qrcode',
            });
          }

          // speakers
          if (this.sidebarMenu.speakers && !this.isSingleSession) {
            this.navigation.push({
              name: 'Speakers',
              path: ROUTES.SPEAKERS.replace(':attendeeId', this.attendeeId),
              icon: 'fa-presentation-screen',
            });
          }

          // ce info/ce's
          if (this.isSingleSession) {
            this.navigation.push({
              name: this.hideCeInformation ? 'Info' : 'CE Info',
              path: ROUTES.CE_INFO.replace(':attendeeId', this.attendeeId),
              icon: 'fa-circle-info',
            });
          } else {
            this.navigation.push({
              name: this.hideCeInformation ? 'Info' : 'CEs',
              path: ROUTES.CE_INFO.replace(':attendeeId', this.attendeeId),
              icon: 'fa-circle-info',
            });
          }

          // exhibit hall
          // if (this.sidebarMenu.exhibit_hall) {
          //   this.navigation.push({
          //     name: 'Exhibit Hall',
          //     path: ROUTES.EXHIBIT_HALL.replace(':attendeeId', this.attendeeId),
          //     icon: 'fa-handshake',
          //   });
          // }

          if (this.$route.name === 'Full Schedule' && this.attendee?.conference?.is_single_session) {
            if (this.$route.query?.post_followup) {
              this.$router.replace({
                name: 'Event Follow Up',
                params: {},
                query: {}
              });
            } else {
              this.$router.replace({name: 'Single Event'});
            }
          } else if (this.$route.name === 'Full Schedule' && this.$route.query?.token) {
            if (this.$route.query?.post_followup) {
              this.$router.replace({
                name: 'Event Follow Up',
                params: {},
                query: {}
              });
            } else {
              this.$router.replace({
                name: this.$route.name,
                params: this.$route.params,
                query: {}
              });
            }
          }

          // if (this.sidebarMenu.materials) {
          //   this.navigation.push({
          //     name: 'Materials',
          //     path: ROUTES.EVENT_MATERIALS.replace(':attendeeId', this.attendeeId),
          //     icon: 'fa-cube',
          //   });
          // }
        }).catch((error) => {
          const status = error?.response?.status;

          // if any response return 404 - redirect to error page
          if ([404, 500].includes(status)) {
            this.$router.push({ name: 'Error Page', params: { status } });
          }
      })
    },
  },
}
</script>

<style scoped lang="scss">


.layout__content {
  //position: absolute;
  //width: 100%;
  //height: 100%;
}

/* Анімації тільки для свайпів */
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.1s ease;
}

.slide-left-enter {
  transform: translateX(100%);
}
.slide-left-leave-to {
  transform: translateX(-100%);
}

.slide-right-enter {
  transform: translateX(-100%);
}
.slide-right-leave-to {
  transform: translateX(100%);
}


.layout {
  display: grid;
  width: 100%;
  height: 100%;

  --sidebar-width: 263px;


  @media (max-width: 1100px) {
    --sidebar-width: 200px;
  }


  &__sidebar {
    width: var(--sidebar-width);
    height: 100%;
    position: relative;
    z-index: 1;


    @media (max-width: 900px) {
      display: none;
    }
  }


  &__mobile-menu {
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    background-color: white;
    box-shadow: 0 3px 10px 0 rgb(0 0 0 / 20%);
    overflow: auto;

    position: fixed;
    bottom: 0;
    left: 0;
    display: none;

    @media (max-width: 900px) {
      display: block;
      //z-index: 27; // check if okay in all places
      z-index: 100;
    }


    ul {
      padding: var(--attendee-gap-lg) var(--attendee-gap-md) 28px var(--attendee-gap-md);
      display: flex;
      gap: 15px;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0;
      width: 100%;

      li {
        //min-width: 63px;
        &.active {
          a {
            color: var(--attendee-brand-color);
          }
        }

        a {
          font-weight: 600;
          white-space: nowrap;
          text-overflow: ellipsis;
          min-width: 100%;
          text-decoration: none;
          display: grid;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 5px;
          font-size: 14px;
          color: var(--attendee-text-secondary-color);

          svg {
            font-size: 21px;
            margin: auto;
          }

          &.router-link-exact-active {
            color: var(--attendee-brand-color);
            font-weight: 600;
          }
        }
      }
    }
  }

  &__right {
  }

  &__header {
    background-color: var(--attendee-background-color);
    position: sticky;
    margin: 0 -15px;
    padding: 0 15px;
    z-index: 30;
    top: 0;
    padding-top: var(--attendee-gap-lg);
    padding-bottom: var(--attendee-gap-md);


    @media (max-width: 900px) {
      display: none;
      padding-left: 0;
    }
  }

  &__notify {
    padding: var(--attendee-gap-md);
  }



  &__content {
    //padding: var(--attendee-gap-md);
    //background-color: white;
    //border-radius: var(--attendee-card-border-radius);
    //box-shadow: var(--attendee-box-shadow);
    margin-top: 5px;
    margin-bottom: var(--attendee-gap-lg);


    //padding-left: var(--sidebar-width);

    @media (max-width: 900px) {
      //padding: 0;
      box-shadow: none;
      margin-top: 0;
    }
  }

  &__container {
    max-width: var(--attendee-container-width);
    margin: 0 auto;
    padding: 0 var(--attendee-gap-md);

    display: grid;
    grid-template-columns: auto 1fr;
    gap: 20px;
    width: 100%;
    height: 100%;

    @media (max-width: 900px) {
      padding: 0;
      display: block;
      padding-top: var(--attendee-header-mobile-height);
      padding-bottom: 100px;
    }


  }
}
</style>
